export default __webpack_public_path__ + "1.18.19/static/media/chevron-right.f060fc1b.svg";